<template>
  <span>
    <!-- シナリオブループリント -->
    <svg class="svg" :width="width" :height="height" :viewBox="viewport" @wheel="zoom" v-if="scenarioTable.length > 0">
      <ConnectPathDemo v-for="(s1, i) in scenarioTable" :key="i" :scenario="s1"></ConnectPathDemo>
      <ScenarioGroupDemo v-for="(s2, i) in scenarioTable" :key="`A-${i}`" :scenario="s2" :ratio="ratio" :dx="dx" :dy="dy"></ScenarioGroupDemo>
    </svg>
  </span>
</template>

<script>
import { mapState } from 'vuex'
import ConnectPathDemo from '@/views/Top/ConnectPathDemo'
import ScenarioGroupDemo from '@/views/Top/ScenarioGroupDemo'
export default {
  name: 'BluePrintDemo',
  componentName: 'BluePrintDemo',
  components: {
    ConnectPathDemo,
    ScenarioGroupDemo
  },
  computed: {
    ...mapState('chatbot', ['scenarioTable'])
  },
  mounted () {
    console.debug('*** Start *** mounted')
    if (localStorage.getItem('demo_ratio') !== null) {
      console.info('demo_ratio is not null')
      this.ratio = Number(localStorage.getItem('demo_ratio'))
    }
    this.makeViewBox(this.dx, this.dy, this.width * this.ratio, this.height * this.ratio)
    console.debug('*** End *** mounted')
  },
  methods: {
    zoom (e) {
      console.debug('*** Start *** zoom')
      console.debug('e: ' + JSON.stringify(e))
      var [x, y, w, h] = this.viewport.split(' ').map(v => parseFloat(v))
      if (e.ctrlKey) {
        console.info('ctrl key is true')
        if (e.deltaY > 0) {
          console.info('deltaY > 0')
           w = w * 1.01
           h = h * 1.01
        } else {
          console.info('deltaY <= 0')
          w = w * 0.99
          h = h * 0.99
        }
        this.makeViewBox(x, y, w, h)
        this.ratio = w / this.width
        localStorage.setItem('demo_ratio', this.ratio)
        e.preventDefault()
      }
      console.debug('*** End *** zoom')
    },
    zoomBtn (d) {
      console.debug('*** Start *** zoomBtn')
      console.debug('d: ' + d)
      var [x, y, w, h] = this.viewport.split(' ').map(v => parseFloat(v))
      w = w * d
      h = h * d
      this.viewport = [x, y, w, h].join(' ')
      this.ratio = w / this.width
      localStorage.setItem('demo_ratio', this.ratio)
      console.debug('*** End *** zoomBtn')
    },
    makeViewBox (x, y, w, h) {
      console.debug('*** Start *** makeViewBox')
      console.debug('x: ' + x)
      console.debug('y: ' + y)
      console.debug('w: ' + w)
      console.debug('h: ' + h)
      this.viewport = [x, y, w, h].join(' ')
      console.debug('*** End *** makeViewBox')
    }
  },
  data () {
    return {
      rxSize: 15,
      width: 1500,
      height: 1000,
      ratio: 2,
      dx: 0,
      dy: 0,
      mapX: 0,
      mapY: 0,
      isMouseDown: false,
      isMouseUp: false,
      isMiniMap: true,
      viewport: '0 0 1500 1000',
      viewportMap: '0 0 1500 1000'
    }
  }
}
</script>

<style scoped>
.svg {
  background-color: #f9f9f9;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%2392aca4' fill-opacity='0.62'%3E%3Cpath opacity='.5' d='M96 95h4v1h-4v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9zm-1 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9z'/%3E%3Cpath d='M6 5V0H5v5H0v1h5v94h1V6h94V5H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}
.svg-map {
  position: absolute;
  left: 0;
  bottom: 0;
  opacity: 0.75;
  border: solidthin #ccc;
  border-radius: 5px;
  background-color: #666;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .6s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Top/BluePrintDemo.vue